import { render, staticRenderFns } from "./server-create-fast.vue?vue&type=template&id=72de857e&scoped=true&"
import script from "./server-create-fast.vue?vue&type=script&lang=js&"
export * from "./server-create-fast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de857e",
  null
  
)

export default component.exports